import { ICON_MAPPING } from './icons'
// import * as battery0 from '@/../images/icons/schulz/battery0.svg'
// import * as battery20 from '@/../images/icons/schulz/battery20.svg'
// import * as battery40 from '@/../images/icons/schulz/battery40.svg'
// import * as battery60 from '@/../images/icons/schulz/battery60.svg'
// import * as battery80 from '@/../images/icons/schulz/battery80.svg'
// import * as battery100 from '@/../images/icons/schulz/battery100.svg'
// import * as chp from '@/../images/icons/schulz/chp.svg'
// import * as container from '@/../images/icons/schulz/container.svg'
// import * as containerAlarm from '@/../images/icons/schulz/container_alarm.svg'
// import * as containerOk from '@/../images/icons/schulz/container_ok.svg'
// import * as containerWarning from '@/../images/icons/schulz/container_warning.svg'
import * as dashboardCenterIcon from '@/../images/icons/schulz/dashboard_center_icon.svg'
// import * as wallbox from '@/../images/icons/schulz/wallbox.svg'
// import * as wallboxPlugged from '@/../images/icons/schulz/wallbox_plugged.svg'
// import * as wallboxUnplugged from '@/../images/icons/schulz/wallbox_unplugged.svg'
// import * as wallboxWarning from '@/../images/icons/schulz/wallbox_warning.svg'
// import * as fuelcell from '@/../images/icons/schulz/fuelcell.svg'
// import * as generic from '@/../images/icons/schulz/generic.svg'
// import * as grid from '@/../images/icons/schulz/grid.svg'
// import * as heatingelement from '@/../images/icons/schulz/heatingelement.svg'
// import * as heatpump from '@/../images/icons/schulz/heatpump.svg'
// import * as pv from '@/../images/icons/schulz/pv.svg'
// import * as rest from '@/../images/icons/schulz/rest.svg'
// import * as trafo from '@/../images/icons/schulz/trafo.svg'
// import * as user from '@/../images/icons/schulz/user.svg'

const map = {
  // battery: battery0,
  // battery0,
  // battery20,
  // battery40,
  // battery60,
  // battery80,
  // battery100,
  // chp,
  // container,
  // containerAlarm,
  // containerOk,
  // containerWarning,
  dashboardCenterIcon
  // fuelcell,
  // generic,
  // grid,
  // heatingelement,
  // heatpump,
  // pv,
  // rest,
  // trafo,
  // user,
  // wallbox,
  // wallboxPlugged,
  // wallboxUnplugged,
  // wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
